if (!customElements.get('td-product-downloads')) {
  class TdProductDownloads extends HTMLElement {
  
    constructor() {
      super();
      this.PRODUCT_DOWNLOADS_JSON = this.getJson(this.dataset.downloadsJson);
      this.activeVariantId = this.dataset.activeVariantId;
      this.activeContent = null;
      this.HIDDEN_CLASS = 'td-hidden';
      
      this.TEAR_SHEET_ELM = this.querySelector('[data-tear-sheet]');
      this.TEAR_SHEET_WRAPPER = this.querySelector('[data-tear-sheet-wrapper]');
      this.CAD_ELM = this.querySelector('[data-cad-file]');
      this.CAD_WRAPPER = this.querySelector('[data-cad-file-wrapper]');
    }
  
    connectedCallback() {
      if (!this.PRODUCT_DOWNLOADS_JSON || !this.TEAR_SHEET_ELM || !this.CAD_ELM || !this.TEAR_SHEET_WRAPPER || !this.CAD_WRAPPER ) {
        return;
      }
      this.KEYED_DOWNLOADS_JSON = this.PRODUCT_DOWNLOADS_JSON.reduce((acc, item) => {
        acc[item.variantId] = item;
        return acc;
      }, {});
      this.setActiveContent();
      this.attachListeners();
    }
  
    attachListeners() {
      document.addEventListener("pdp:variant-changed", (event) => {
        this.activeVariantId = event.detail?.variant?.id;
        this.setActiveContent();
      });
    }
  
    setActiveContent() {
      this.activeContent = this.KEYED_DOWNLOADS_JSON[this.activeVariantId];

      if (!this.activeContent.tearSheet && !this.activeContent.cadFile) {
        this.classList.add(this.HIDDEN_CLASS)
        return;
      } else {
        this.classList.remove(this.HIDDEN_CLASS)
      }

      if (this.activeContent.tearSheet) {
        this.TEAR_SHEET_WRAPPER.classList.remove(this.HIDDEN_CLASS)
        this.TEAR_SHEET_ELM.href = this.activeContent.tearSheet;
      } else {
        this.TEAR_SHEET_WRAPPER.classList.add(this.HIDDEN_CLASS)
      }

      if (this.activeContent.cadFile) {
        this.CAD_WRAPPER.classList.remove(this.HIDDEN_CLASS)
        this.CAD_ELM.href = this.activeContent.cadFile;
      } else {
        this.CAD_WRAPPER.classList.add(this.HIDDEN_CLASS)
      }
    }
  
    getJson(str) {
      try {
        return JSON.parse(str);
      } catch (err) {
        return null;
      }
    }
    
  }
  customElements.define('td-product-downloads', TdProductDownloads);
}

